import { lazy, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { CREATE_QUOTE_URL } from "../../apiConfig";
import { PAYMENT_OPTIONS_PAGE_ROUTE, QUICK_QUOTE_ROUTE } from "../../routes";
import { getDomain } from "../../../Utilities/utils";
import { getLocalData } from "../../../Utilities/Common/source";
import Swal from "sweetalert2";
import axiosInstance from "../../../Utilities/djangoAxiosInstance";

const ProposerDetailsForm = lazy(() =>
  import("./Components/ProposerForm/ProposerDetailsForm")
);
const InsuredsDetailsForm = lazy(() =>
  import("./Components/InsuredForm/InsuredDetailsForm")
);
const NomineeDetailsForm = lazy(() =>
  import("./Components/NomineeForm/NomineeDetailsForm")
);
const MedicalQuestionnaire = lazy(() =>
  import("./Components/MedicalForm/MedicalQuestionnaireForm")
);

const useGoDigitCQ = ({ transferData, transferDataId }) => {
  const localSource = getLocalData("source");
  console.log("uOSCQ localSource: ", localSource);
  const steps = [
    ProposerDetailsForm,
    InsuredsDetailsForm,
    MedicalQuestionnaire,
    NomineeDetailsForm,
  ];

  const stepsLabel = ["Proposer", "Insureds", "Medical", "Nominee"]; // label for the steps/tabs

  const navigate = useNavigate();
  const [finalData, setFinalData] = useState({});
  const [activeStep, setActiveStep] = useState(0);

  const [loading, setLoading] = useState(false);

  const onSubmit = async (data) => {
    setFinalData((prevData) => ({ ...prevData, ...data }));
    if (activeStep < steps.length - 1) {
      setActiveStep((prevStep) => prevStep + 1);
      window.scrollTo(0, 0);
      return;
    }

    // Send form data to the server
    const domain = getDomain();
    try {
      setLoading(true);
      const response = await axiosInstance.post(
        `${CREATE_QUOTE_URL}/${transferData.A_id}/${transferDataId}/`,
        JSON.stringify({ ...finalData, ...data }),
        {
          params: {
            source: localSource,
          }
        }
      );
      setLoading(false);
      console.log("goDigit response: ", response?.data);
      if (response.status === 200)
        navigate(`${PAYMENT_OPTIONS_PAGE_ROUTE}/${transferDataId}`);
    } catch (error) {
      console.log("error: ", error?.response);
      const err_res = error?.response?.data;
      setLoading(false);
      if (err_res?.personUWStatus === "DPM") {
        // alert(err_res?.message?.errorMessage);
        Swal.fire({
          title: "Policy Declined",
          text: `${err_res?.message?.errorMessage}`,
          icon: "warning",
          confirmButtonColor: "#0d409b",
          cancelButtonColor: "#d33",
          cancelButtonText: "Go to Quick Quote",
          showCancelButton: true,
          reverseButtons: true,
        }).then((result) => {
          const stateToPass = {
            source: getLocalData("source"),
          };
          if (result.dismiss === Swal.DismissReason.cancel) {
            navigate(QUICK_QUOTE_ROUTE, { state: stateToPass });
          }
          navigate(QUICK_QUOTE_ROUTE, { state: stateToPass });
        });
      } else if (
        err_res?.Error &&
        err_res?.Error["Retail Health-Create Quote"]?.Error
      ) {
        try {
          const err_obj = JSON.parse(
            err_res?.Error["Retail Health-Create Quote"]?.Error
          );
          console.log("errorji...", err_obj?.error?.errorMessage);
          alert(err_obj?.error?.errorMessage);
        } catch (e) {
          alert(err_res?.Error["Retail Health-Create Quote"]?.Error);
        }
      } else {
        alert(err_res?.Error);
      }
    }
  };

  const onBack = () => {
    if (activeStep > 0) {
      setActiveStep((prevStep) => prevStep - 1);
    } else {
      navigate(-1);
    }
  };

  console.log("finalData: ", finalData);

  const CurrentStep = steps[activeStep];

  /**
   * Handles the click event on tabs/steps of the stepper.
   *
   * @param {number} index - The index of the clicked step/tab.
   * @returns {void}
   */
  const handleStepClick = (index) => {
    // Ensure index is within valid range and not ahead of the active step
    if (index < 0 || index > steps.length - 1 || index >= activeStep) return;

    // Set the active step to the clicked index
    setActiveStep(index);
  };

  return {
    transferData,
    onBack,
    onSubmit,
    finalData,
    loading,
    CurrentStep,
    stepsLabel,
    activeStep,
    handleStepClick,
  };
};

export default useGoDigitCQ;
